import { pathOr } from 'ramda';

import { IState } from '../../store';
import { IPhotoSchema } from '../../types/newbuildingTiledCarousel';

export const getPhotos = (state: IState): IPhotoSchema[] => {
  const photos = pathOr([] as IPhotoSchema[], ['offerData', 'offer', 'photos'], state);

  return photos.filter(item => !item.isLayout);
};

export function getCountSelector(state: IState) {
  const photos = pathOr([] as IPhotoSchema[], ['offerData', 'offer', 'photos'], state);

  return photos.length;
}
